import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { EditorPage, MyCreatives, NewCreative, SettingsPage } from './pages';

export const AdsGeneratorEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Generator reklam',
      element: <NewCreative />,
      path: '/',
    },
    {
      label: 'Moje kreacje',
      element: <MyCreatives />,
      path: '/creatives',
    },
    {
      label: 'Edytor',
      element: <EditorPage />,
      path: '/editor',
    },
    {
      label: 'Ustawienia',
      element: <SettingsPage />,
      path: '/settings',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
